@if (team) {
  <div class="pl-1 team-name">
    @if (team) {
      <h1 [ngClass]="{ archived: teamIsArchived() }" id="team-name-header">
        {{ team.name }}
      </h1>
    }
    @if (team?.dateRange.toString('mediumDate', 'utc'); as teamDates) {
      <span class="date-range">{{ teamDates }}</span>
    }
  </div>
}
<div class="team-header-actions">
  @if (team && team.hasCommunity()) {
    <button
      (click)="openHigherLogicSettings()"
      class="action-buttons"
      mat-icon-button
      [matTooltip]="'Team synced with a Higher Logic community' | platformLabel"
      matTooltipShowDelay="500"
      [attr.aria-label]="
        'Team synced with a Higher Logic community' | platformLabel
      "
    >
      <mat-icon>
        <img src="../assets/img/HigherLogicThumb.png" />
      </mat-icon>
    </button>
  }
  <button
    class="action-buttons"
    mat-stroked-button
    [matMenuTriggerFor]="menu"
    matTooltip="More actions"
    aria-label="More actions"
    matTooltipShowDelay="500"
    id="more-actions-button"
  >
    Actions <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    <mat-menu #menu="matMenu">
      <app-export-confirmation
        [viewContext]="viewContext"
        [getExportRequest]="getExportRequest"
        extraDescription="team as"
        [hasIcon]="true"
      >
      </app-export-confirmation>
      @if (team) {
        <button mat-menu-item (click)="viewTeamRosterReport(team.name)">
          <mat-icon>summarize</mat-icon>
          <span>{{ 'View Team in Roster Report' | platformLabel }}</span>
        </button>
      }
      @if (canEditTeam()) {
        <div>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="openEditTeamDialog()"
            [disabled]="teamIsArchived()"
            id="edit-team-button"
          >
            <mat-icon>edit</mat-icon>
            <span>{{ 'Edit Team' | platformLabel }}</span>
          </button>
          <button
            mat-menu-item
            (click)="openPositionDialog()"
            [disabled]="teamIsArchived()"
          >
            <mat-icon>add</mat-icon>
            <span>Add Position</span>
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="invitePicked()"
            [disabled]="team?.getPickedCount() == 0"
            id="invite-all-team-button"
          >
            <mat-icon>send</mat-icon>
            <span>{{ 'Invite All to Team' | platformLabel }}</span>
          </button>
          <button
            mat-menu-item
            (click)="remindInvited()"
            [disabled]="team?.getInvitedCount() == 0"
            id="remind-all-team-button"
          >
            <mat-icon>send</mat-icon>
            <span>Send reminder to invited</span>
          </button>
          <button
            mat-menu-item
            (click)="emailTeam()"
            [disabled]="!team?.hasPeopleOnSeats"
          >
            <mat-icon>email</mat-icon>
            <span>{{ 'Email Team' | platformLabel }}</span>
            @if (doesSendTeamEmailRequirePlanUpgrade()) {
              <mat-icon class="locked">lock</mat-icon>
            }
          </button>
          <button
            mat-menu-item
            (click)="openSendEvaluation()"
            [disabled]="!teamHasPositions"
          >
            <mat-icon>equalizer</mat-icon>
            <span>Send Evaluation</span>
          </button>
          @if (isSurveyEnabled) {
            <button
              mat-menu-item
              (click)="openSendSurvey()"
              [disabled]="!canSendSurvey() || !teamHasPositions"
            >
              <mat-icon>equalizer</mat-icon>
              <span>{{ 'Send Team Survey' | platformLabel }}</span>
            </button>
          }
          <button
            mat-menu-item
            (click)="openSendTeamForm()"
            [disabled]="!teamHasPositions"
          >
            <mat-icon>equalizer</mat-icon>
            <span>{{ 'Send Team Form' | platformLabel }}</span>
          </button>
          @if (team && team.hasCommunity()) {
            <button mat-menu-item (click)="openHigherLogicSettings()">
              <mat-icon>extension</mat-icon>
              <span>Higher Logic Settings</span>
            </button>
          }
          <mat-divider></mat-divider>
          @if (team && !team.hasCommunity()) {
            <button mat-menu-item (click)="createHigherLogicCommunity()">
              <mat-icon>extension</mat-icon>
              <span>Create Higher Logic Community</span>
            </button>
          }
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="openCloneDialog()">
            <mat-icon>content_copy</mat-icon>
            <span>{{ 'Clone Team' | platformLabel }}</span>
          </button>
          @if (!teamIsArchived()) {
            <button mat-menu-item (click)="archiveTeam()">
              <mat-icon>archive</mat-icon>
              <span>{{ 'Archive Team' | platformLabel }}</span>
            </button>
          }
          @if (teamIsArchived()) {
            <button mat-menu-item (click)="unarchiveTeam()">
              <mat-icon>unarchive</mat-icon>
              <span>{{ 'Unarchive Team' | platformLabel }}</span>
            </button>
          }
          @if (canMigrateTeamToWorkspace()) {
            <button
              mat-menu-item
              (click)="
                teamMigrationDialog.openModal(
                  team.id,
                  team.name,
                  currentWorkspaces
                )
              "
            >
              <mat-icon>drive_file_move</mat-icon>
              <span>{{ 'Migrate Team to Workspace' | platformLabel }}</span>
            </button>
          }
          @if (canDeleteTeam()) {
            <button
              mat-menu-item
              class="team-delete"
              (click)="openDeleteTeamDialog()"
              id="delete-team-button"
            >
              <mat-icon>delete</mat-icon>
              <span>{{ 'Delete Team' | platformLabel }}</span>
            </button>
          }
        </div>
      }
    </mat-menu>
  </button>
  <ng-content></ng-content>
</div>
<team-workspace-migration #teamMigrationDialog> </team-workspace-migration>
